import { deleteField, doc, getDoc, serverTimestamp, updateDoc } from 'firebase/firestore';
import type { MemberPermissionOverrides } from '@finvox/shared/member-access';
import { getFirestoreDb } from '@/lib/firebase';
import { normalizeMemberPermissionPayload } from './permissions';

export async function updateOrgMemberPermissions(
  orgId: string,
  targetUid: string,
  permissions: MemberPermissionOverrides | null
): Promise<{ ok: true }> {
  const memberRef = doc(getFirestoreDb(), 'organizations', orgId, 'members', targetUid);
  const snap = await getDoc(memberRef);
  if (!snap.exists()) throw new Error('Member not found');
  if (snap.data()?.role === 'owner') throw new Error('Cannot change owner permissions');

  if (permissions === null) {
    await updateDoc(memberRef, {
      permissions: deleteField(),
      cashbookPermissions: deleteField(),
      updatedAt: serverTimestamp()
    });
    return { ok: true };
  }

  const normalized = normalizeMemberPermissionPayload(permissions);
  if (!normalized) throw new Error('No permissions provided');

  await updateDoc(memberRef, {
    permissions: normalized,
    cashbookPermissions: deleteField(),
    updatedAt: serverTimestamp()
  });
  return { ok: true };
}
